import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pressure_vessels_safety'

export const dataPointDefinition = {
  retracedId: 'pressure_vessels_safety',
  name: 'Pressure vessels safety',
  description: 'Select Not Applicable if the facility did not have any pressure vessels during the assessment period.',
  meta: {
    slcpMeta: {
      key: 'ms-1--12-9x',
      number: 'MS-PLA-14-9',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'ms-pla-29',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],ms-1--2-14x',
      machineShowHide: '[2],ms-1--2-14x',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'ms-pla-29',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1--12-9x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32160,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
